import { render, staticRenderFns } from "./LandingScreen.vue?vue&type=template&id=f2833af6&scoped=true"
import script from "./LandingScreen.vue?vue&type=script&lang=js"
export * from "./LandingScreen.vue?vue&type=script&lang=js"
import style0 from "./LandingScreen.vue?vue&type=style&index=0&id=f2833af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2833af6",
  null
  
)

export default component.exports